import { useNavigate } from 'react-router-dom';
import { ArrowForward } from '@mui/icons-material';
import { InfoContainer } from '@/components/base/info-container.component';
import { useTranslation } from 'react-i18next';

export function EmptyShoppingCart() {
  const navigate = useNavigate();
  const { t } = useTranslation('cart');

  return (
    <InfoContainer
      title={t('empty.title')}
      description={t('empty.description')}
      button={{
        text: t('empty.shopButton'),
        startIcon: <ArrowForward />,
        onClick: () => navigate('/bp/c/items'),
      }}
    />
  );
}
